<template>
  <div
    class="content_main rounded-0 pt-content"
    :class="{'bg_c9': !isThaiCharoenPlus}"
  >
    <div class="container">
      <div class="row">
        <div
          v-for="(item,i) in yeekeeTabItems"
          :key="i"
          class="col-12 col-md-6 col-lg-4 mt-4 animateMe" 
          data-animation="fadeInUp"
        >
          <div 
            class="bg_c9 bdr-10 h-100 box_shadow"
          >
            <div class="table-responsive table-height">
              <table class="table table-bg table-hover mb-0">
                <thead>
                  <tr class="t-medium c-white">
                    <th
                      scope="col"
                      colspan="3"
                    >
                      {{ item.name }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="t-medium">
                    <th scope="col">
                      รอบที่
                    </th>
                    <th
                      scope="col"
                      class="text-center"
                    >
                      3 ตัวบน
                    </th>
                    <th
                      scope="col"
                      class="text-center"
                    >
                      2 ตัวล่าง
                    </th>
                  </tr>
                  <tr
                    v-for="(round, j) in getCommentRounds(item.game_rounds)" 
                    :key="j"
                  >
                    <td>{{ round.name }}</td>
                    <td class="text-center">
                      {{ getWinNumber(round)['three_up'] }}
                    </td>
                    <td class="text-center">
                      {{ getWinNumber(round)['two_down'] }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div
          v-if="govLotto"
          class="col-12 col-md-6 col-lg-3 mt-4 animateMe"
          data-animation="fadeInUp"
        >
          <div class="bg_c9 bdr-10 h-100 box_shadow">
            <div class="table-responsive table-height">
              <table class="table table-bg table-hover mb-0">
                <thead>
                  <tr class="t-medium c-white">
                    <th
                      scope="col"
                      colspan="2"
                    >
                      <div class="d-flex align-items-center justify-center">
                        <div class="img-flag me-3">
                          <!-- <img src="./assets/img/flag/th.png" alt="" /> -->
                        </div>
                        {{ govLotto.game_rounds[0].name || '-' }}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>รางวัลที่ 1</td>
                    <td class="text-center">
                      {{ getWinNumber(govLotto.game_rounds[0].round_rooms[0])['win_number'] || '-' }} 
                    </td>
                  </tr>
                  <tr>
                    <td>3 ตัวหน้า</td>
                    <td class="text-center">
                      {{ getWinNumber(govLotto.game_rounds[0].round_rooms[0])['three_down_first'] || '-' }} 
                    </td>
                  </tr>
                  <tr>
                    <td>3 ตัวล่าง</td>
                    <td class="text-center">
                      {{ getWinNumber(govLotto.game_rounds[0].round_rooms[0])['three_down_second'] || '-' }} 
                    </td>
                  </tr>
                  <tr>
                    <td>2 ตัวล่าง</td>
                    <td class="text-center">
                      {{ getWinNumber(govLotto.game_rounds[0].round_rooms[0])['two_down'] || '-' }} 
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div
          v-for="(item,i) in cardLottoItems"
          :key="i"
          class="col-12 col-md-12 col-lg-5 mt-4 animateMe"
          data-animation="fadeInUp"
        >
          <div class="bg_c9 bdr-10 h-100 box_shadow">
            <div class="table-responsive table-height">
              <table class="table table-bg table-hover mb-0">
                <thead>
                  <tr class="t-medium c-white">
                    <th
                      scope="col"
                      colspan="3"
                    >
                      {{ item.name }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="t-medium">
                    <th scope="col">
                      ประเทศ
                    </th>
                    <th
                      scope="col"
                      class="text-center"
                    >
                      3 ตัวบน
                    </th>
                    <th
                      scope="col"
                      class="text-center"
                    >
                      2 ตัวล่าง
                    </th>
                  </tr>
                  <tr
                    v-for="(round, j) in item.game_rounds" 
                    :key="j"
                  >
                    <td>
                      <div
                        class="d-flex align-items-center"
                        style="white-space: nowrap"
                      >
                        <div class="img-flag me-3">
                          <!-- <img src="./assets/img/flag/sp.png" alt="" /> -->
                        </div>
                        {{ round.name }}
                      </div>
                    </td>
                    <td class="text-center">
                      {{ getWinNumber(round)['three_up'] || '-' }}
                    </td>
                    <td class="text-center">
                      {{ getWinNumber(round)['two_down'] || '-' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { anonymous as apiAnonymous } from '@/apis'
import { 
  YEEKEE, 
  YEEKEE_SPEED, 
  YEEKEE_TEN_MIN, 
  HUAY_FAH,
  HUAY_FAH_VIP,
  LOTTO, 
  FOREIGN_LOTTO , 
} from '@/const/gameId'


export default {  
  components : {
  },

  data: () => ({
    yeekeeTabItems:[],
    cardLottoItems:[],  
    govLotto: false,
  }),

  computed : { 
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    yeekeeTabDisplay () {
      return [YEEKEE,YEEKEE_SPEED,YEEKEE_TEN_MIN,HUAY_FAH,HUAY_FAH_VIP]
    },
    foreignCardLottoDisplay () {
      return [FOREIGN_LOTTO]
    }
  }, 

  async created () {
      await this.load() 
  },   

  methods: {  
    async load () {
      const [err,data ] = await apiAnonymous.getLastWin()

      console.log(data)

      if(err) {
        return
      }
      
      this.yeekeeTabItems = data.filter(x=>this.yeekeeTabDisplay.includes(x.id))
      this.cardLottoItems = data.filter(x=>this.foreignCardLottoDisplay.includes(x.id))
      this.govLotto = data.find(x=>x.id===LOTTO) 
    },

    getCommentRounds ($items) {
      return $items.filter(x => x.round_status.id != 1)
    },

    getWinNumber (item) {
      const roundRooms = (item['round_rooms'] || [])[0] || {}
      const winNumber = roundRooms['win_number'] || {}
      return winNumber
    },
  }
}
</script>
<style scoped>
.content_main {
  border-radius: 20px 20px 0 0;
  padding-bottom: 20px;
}

.h-100 {
  height: 100% !important;
}

.bg_c9 {
  background: var(--v3-sec-color-20);
}

.bdr-10 {
  border-radius: 10px;
  overflow: hidden;
  background-color: white;
}

.c-white {
  color: #fff;
}

.box_shadow {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}

.table-bg {
  background: #fff;
}
.table-bg thead {
  width: 100%;
  background: var(--v3-header-table);
}
.table-bg thead th,
.table-bg thead td {
  border-bottom: none;
  padding: 15px 20px;
  white-space: nowrap;
}
.table-bg tbody {
  border-top: none;
}
.table-bg tbody th,
.table-bg tbody td {
  padding: 15px 20px;
}

.table {
  --bs-table-bg: transparent;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: #212529;
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: #212529;
  --bs-table-active-bg: rgba(0, 0, 0, 0.1);
  --bs-table-hover-color: #212529;
  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: top;
  border-color: #dee2e6;
  border-spacing: 0;
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}
.table > :not(:first-child) {
  border-top: 2px solid currentColor;
}

.table-height {
  max-height: 550px;
  overflow: auto;
}
.table-height .table tbody tr:first-child {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #fff;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color);
}

.table-active {
  --bs-table-accent-bg: var(--bs-table-active-bg);
  color: var(--bs-table-active-color);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-accent-bg: var(--bs-table-hover-bg);
  color: var(--bs-table-hover-color);
}

.table-primary {
  --bs-table-bg: #cfe2ff;
  --bs-table-striped-bg: #c5d7f2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bacbe6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfd1ec;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #bacbe6;
}

.table-secondary {
  --bs-table-bg: #e2e3e5;
  --bs-table-striped-bg: #d7d8da;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #cbccce;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d1d2d4;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #cbccce;
}

.table-success {
  --bs-table-bg: #d1e7dd;
  --bs-table-striped-bg: #c7dbd2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bcd0c7;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c1d6cc;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #bcd0c7;
}

.table-info {
  --bs-table-bg: #cff4fc;
  --bs-table-striped-bg: #c5e8ef;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #badce3;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfe2e9;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #badce3;
}

.table-warning {
  --bs-table-bg: #fff3cd;
  --bs-table-striped-bg: #f2e7c3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6dbb9;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ece1be;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #e6dbb9;
}

.table-danger {
  --bs-table-bg: #f8d7da;
  --bs-table-striped-bg: #eccccf;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfc2c4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5c7ca;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #dfc2c4;
}

.table-light {
  --bs-table-bg: #f8f9fa;
  --bs-table-striped-bg: #ecedee;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfe0e1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5e6e7;
  --bs-table-hover-color: #000;
  color: #000;
  border-color: #dfe0e1;
}

.table-dark {
  --bs-table-bg: #212529;
  --bs-table-striped-bg: #2c3034;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #373b3e;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #323539;
  --bs-table-hover-color: #fff;
  color: #fff;
  border-color: #373b3e;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

</style>